import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVTypeData, updateVTypeData, addVTypeData } from "../../slices/panelSlice";
import Pagination from "../../components/Pagination";
import Loader from "../../components/Loader";
import EditableTable from "./VariableTypeTable";
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";
import Swal from "sweetalert2";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

function VariableType({editable}) {
  const dispatch = useDispatch();
  const { VTypeData, status, error } = useSelector((state) => state.panel);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(VTypeData?.result)
    ? VTypeData?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(VTypeData?.result)
    ? Math.ceil(VTypeData?.result?.length / itemsPerPage)
    : 0;
  const headers =
    VTypeData?.result?.length > 0
      ? Object.keys(VTypeData.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title"]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);

  const [addModal,setAddModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchVTypeData());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }


  const handleAddVariable = () => {
    Swal.fire({
      title: "Add Variable Type",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Add",
      showLoaderOnConfirm: true,
      inputValidator: (value) => {
        if (!value) {
          return "Variable type is required!";
        }
        if (value.length < 3) {
          return "Variable type must be at least 3 characters long!";
        }
        if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
          return "Variable type can only contain letters, numbers, and spaces!";
        }
        const isExist = VTypeData?.result?.some(f=>f.title===value)
        if(isExist){
          return "This variable type is already exists."
        }

      },
      preConfirm: async (inpVal) => {
        try {
          const response = await api.post("/panel/VType", { title: inpVal });
          alertSuccess("Variable type added successfully.");
          dispatch(fetchVTypeData());
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(
            error.response?.data?.errors || error.message
          );
        }
      },allowOutsideClick:false
    });
  };
  

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = VTypeData.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, title } = editedData;
    const updatedData = { id, title };
    console.log(updatedData);
    const resp = await dispatch(updateVTypeData(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchVTypeData());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (field === "active") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = VTypeData.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    openModal();
  };

  return (
    <>
      <div className="flex items-center flex-col">
        <EditableTable
          headers={headers}
          rows={currentItems}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          editableFields={editableFields} // Pass editable fields
          editable={editable}
        />
  
       

        <div className="flex mt-4 items-center justify-between w-11/12">
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />

          {/* <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setAddModal(true)}>
            + Add Variable Type
          </button> */}
          {editable && 
          <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={handleAddVariable}>
            + Add Variable Type
          </button>
          }
        </div>
      </div>



{/* Modal for add variable type */}
{/* 
<Modal
        isOpen={addModal}
        onClose={()=>setAddModal(false)}
        title="Add Variable Type"
        content={<>
             <div class="w-full max-w-sm min-w-[200px]">
  <input class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Enter variable type here" />
</div>

<div className="flex">
<button className="activeBtn text-white text-sm px-2 py-1 rounded mt-2 mx-auto">+ Add Variable Type </button>

</div>

        </>}
      /> */}

 {/* MOdal For Change Log */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </>
  );
}

export default VariableType;
